
import utils from '@/mixins/utils'
export default {
  mixins: [utils],
}
